import { Outlet } from "react-router-dom"
import Menu from "../Menu/Menu"
import menuConfig from '../../config/publicMenu.json'

const Layout = () => {
  return <div>
    <Menu
      config={menuConfig}
    />
    <Outlet></Outlet>
  </div>
}

export default Layout